export default () => ({
    selectedTmcProcessingProject: null,
    searchQueryData: {
        query: '',
        sort: {icon: 'sort-alphabetical-ascending', text: 'Alphabetically ascending', value: 'ASCENDING'},
        projectType: {icon: '', text: 'All', value: 'ALL'},
        active: {icon: 'calendar-check', text: 'Active', value: 'Active'},
    },
    selectedTmcProcessingDevice: null,
    selectedTmcVideoCalibrations: null,
    selectedTmcCalibration: null,
    dpLegendSelection: {
        CREATED: {name: 'Created', value: true, color: '#8C84FF'},
        RUNNING: {name: 'Running', value: true, color: '#D8BA13'},
        COMPLETED: {name: 'Completed', value: true, color: '#1CAB80'},
        FAILED: {name: 'Failed', value: true, color: '#e02c2c'},
        NO_TASKS: {name: 'No Tasks', value: true, color: 'black'}
    }
});
